<template>
    <button :type="type" class="btn" :class="[color, size]">
        <i class="bi" :class="icon"></i>
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'ButtonNormal',
    props: {
        text: {
            type: String,
            default: 'キャンセル',
        },
        icon: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'button',
        },
        color: {
            type: String,
            default: 'btn-primary'
        },
        size: {
            type: String,
            default: '',
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
